import * as THREE from 'three'

import Experience from '../Experience.js'

export default class Environment {
  constructor () {
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.resources = this.experience.resources
    this.debug = this.experience.debug

    // Debug

    this.debugFolder = this.debug.ui.addFolder('environment')

    this.setSunLight()
    // this.setEnvironmentMap()
  }

  setSunLight () {
    this.ambientLight = new THREE.AmbientLight('#ffffff', 6)
    this.pointLight = new THREE.PointLight('#ffffff', 0)
    this.pointLight.position.set(-190, 117, 260)
    const pointLightHelper = new THREE.PointLightHelper(this.pointLight, 1)

    // this.scene.add(this.ambientLight)
    this.scene.add(this.pointLight)
    this.scene.add(this.ambientLight)
    this.scene.add(pointLightHelper)

    // Debug
    this.debugFolder
      .add(this.ambientLight, 'intensity')
      .name('ambientlightintensity')
      .min(0)
      .max(20)
      .step(0.001)
    this.debugFolder
      .add(this.pointLight, 'intensity')
      .name('pointLightIntensity')
      .min(0)
      .max(20)
      .step(0.001)

    this.debugFolder
      .add(this.pointLight.position, 'x')
      .name('pointLightX')
      .min(-350)
      .max(350)
      .step(0.001)

    this.debugFolder
      .add(this.pointLight.position, 'y')
      .name('pointLightY')
      .min(-350)
      .max(350)
      .step(0.001)

    this.debugFolder
      .add(this.pointLight.position, 'z')
      .name('pointLightZ')
      .min(-350)
      .max(350)
      .step(0.001)
  }

  setEnvironmentMap () {
    this.environmentMap = {}
    this.environmentMap.intensity = 200
    this.environmentMap.texture = this.resources.items.environmentMapTexture
    this.environmentMap.texture.encoding = THREE.sRGBEncoding

    this.scene.environment = this.environmentMap.texture

    this.environmentMap.updateMaterials = () => {
      this.scene.traverse((child) => {
        if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
          child.material.envMap = this.environmentMap.texture
          child.material.envMapIntensity = this.environmentMap.intensity
          child.material.needsUpdate = true
        }
      })
    }
    this.environmentMap.updateMaterials()

    // Debug
    if (this.debug.active) {
      this.debugFolder
        .add(this.environmentMap, 'intensity')
        .name('envMapIntensity')
        .min(0)
        .max(4)
        .step(0.001)
        .onChange(this.environmentMap.updateMaterials)
    }
  }
}
